import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Menu, MenuItem, makeStyles } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { styled } from '@mui/material/styles';
import { IconButton, IconTooltip } from 'components';
import { isoStringDisplay } from 'utilities';
import {
  UserContentFlashcard,
  UserContentHighlight,
  UserContentNote,
} from 'types';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  '&:focus-visible': {
    outlineColor: 'rgba(4, 60, 116, 1)',
    outlineOffset: theme.spacing(-0.25),
    outlineStyle: 'solid',
    outlineWidth: theme.spacing(0.25),
  },
}));

const useStyles = makeStyles((theme) => ({
  hidden: {
    display: 'none',
  },
}));

const OptionsMenu = ({
  cardId,
  menuItemsList = [],
  userContentItem,
  ...props
}) => {
  const classes = useStyles();
  const [anchorElement, setAnchorElement] = useState(null);

  const handleCloseMenu = () => {
    setAnchorElement(null);
  };
  const handleShowMenu = (event) => {
    setAnchorElement(event.currentTarget.parentElement);
  };

  let typeString;
  if (userContentItem instanceof UserContentFlashcard) {
    typeString = 'flashcard';
  } else if (userContentItem instanceof UserContentHighlight) {
    typeString = 'highlight';
  } else if (userContentItem instanceof UserContentNote) {
    typeString = 'note';
  }

  return (
    <div {...props}>
      <div className={classes.hidden} id={`options-menu-label-${cardId}`}>
        Options for {typeString} created at{' '}
        <span className="noTranslate">
          {isoStringDisplay(userContentItem.dateCreated)}
        </span>
      </div>
      <IconTooltip id="options-menu" title="Options">
        <IconButton
          aria-labelledby={`options-menu-label-${cardId}`}
          aria-controls={`options-menu-${cardId}`}
          aria-haspopup="true"
          aria-pressed={Boolean(anchorElement)}
          onClick={handleShowMenu}
        >
          <MoreVert />
        </IconButton>
      </IconTooltip>
      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        id={`options-menu-${cardId}`}
        getContentAnchorEl={null}
        keepMounted
        open={Boolean(anchorElement)}
        onClose={(_, reason) => {
          // default MUI behavior is to close on Escape KeyDown, but we want Menu to close on keyUp instead. So prevent close on KeyDown
          if (reason !== 'escapeKeyDown') {
            handleCloseMenu();
          }
        }}
        onKeyUp={(e) => {
          e.stopPropagation();
          if (e.key === 'Escape') {
            handleCloseMenu();
          }
        }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {menuItemsList.map(({ key, displayText, onClick }, index) => (
          <StyledMenuItem
            key={`options-menu-${key ?? index}`}
            onClick={() => {
              handleCloseMenu();
              onClick();
            }}
          >
            {displayText}
          </StyledMenuItem>
        ))}
      </Menu>
    </div>
  );
};

OptionsMenu.propTypes = {
  cardId: PropTypes.string,
  menuItemsList: PropTypes.array,
  userContentItem: PropTypes.object.isRequired,
};

export default OptionsMenu;
